import React from "react";
import { Info } from "lucide-react";

interface StatCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  iconBgColor: string;
  iconColor: string;
  onInfoClick?: () => void;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  value,
  iconBgColor,
  iconColor,
  onInfoClick,
}) => (
  <div className="bg-white rounded shadow p-6 flex items-start gap-4">
    <div
      className={`${iconBgColor} ${iconColor} p-3 rounded-lg flex items-center justify-center`}
    >
      {icon}
    </div>
    <div className="flex-1">
      <div className="flex items-center gap-1.5">
        <p className="text-gray-600 text-sm mb-1">{title}</p>
        {onInfoClick && (
          <button
            onClick={onInfoClick}
            className="text-gray-400 hover:text-gray-600 transition-colors mb-1"
            aria-label={`Info about ${title}`}
          >
            <Info size={14} />
          </button>
        )}
      </div>
      <p className="text-3xl font-bold text-gray-900">{value}</p>
    </div>
  </div>
);

export default StatCard;
